import { createAction } from '@reduxjs/toolkit'
import { firstValueFrom } from 'rxjs'
import { PPAddOnUpdate, PPProduct } from 'shared'
import { createAppAsyncThunk } from 'store/state'
import { V1 } from './net'

export const upgradeSuccess = createAction<{ newPlan: string, productInfo: PPProduct | undefined }>(
  'ACTION_UPGRADE_SUCCESS'
)

/**
 * Adds, changes or removes subscription add-ons.
 *
 * Send only the add-ons whose quantity changed, each with the NEW total quantity (0 removes it).
 */
export const manageAddOns = createAppAsyncThunk(
  'product/manageAddOns',
  async (addons: PPAddOnUpdate[], { dispatch, rejectWithValue }) => {
    try {
      const response: any = await firstValueFrom(dispatch(V1.manageAddOns(addons)))
      if (response?.status === 'error' || response?.error) {
        return rejectWithValue(response.error || { message: response.msg })
      }
      return {
        adminLimit: response.adminLimit,
        aiImagesLimit: response.aiImagesLimit,
        profilesLimit: response.profilesLimit,
        // Missing when the backend leaves add-ons out of the response - the change is already applied either way
        addons: response.addons?.active as Record<string, number> | undefined,
        pendingDrops: response.addons?.pendingDrops as Record<string, number> | undefined
      }
    } catch (error: any) {
      return rejectWithValue(error?.response?.error || error)
    }
  }
)

export const migrateToStripe = createAppAsyncThunk(
  'product/migrateToStripe',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.migrateToStripe()))
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
